import { Box, Alert } from "@mui/material";

export const ErrorState = ({ error }: { error: string }) => {
  const isComparisonNotSupported = error.includes("Comparison for this view is not supported");
  return (
    <Box p={2}>
      <Alert severity={isComparisonNotSupported ? "info" : "error"}>{error}</Alert>
    </Box>
  );
};
